import { render } from "./OrganizationChartNode.vue?vue&type=template&id=2e2bd37c"
import script from "./OrganizationChartNode.vue?vue&type=script&lang=js"
export * from "./OrganizationChartNode.vue?vue&type=script&lang=js"

import "./OrganizationChartNode.vue?vue&type=style&index=0&id=2e2bd37c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__